import React, { useState, useEffect } from 'react';
import { Grid, Button, Typography, FormControl, Box, InputLabel, Select, MenuItem, Input } from '@mui/material';
import FilterIcon from '@mui/icons-material/FilterList';
import { useSelector, useDispatch } from 'react-redux';
import { get, set } from 'global/lib/lodash';
import setFilter from 'redux/actions/setFilter';
import { UserFilter } from 'global/utils/filter';
import { CourseDisplay } from 'global/lib/filter';
import { useScreen } from 'global/styles';
import useStyles from 'global/styles/filters';
import DiagContainer from 'global/components/diag-container';

export default function PerformTasksFilters({ display, vendors }) {
  const [showFilters, setShowFilters] = useState(false);
  const filter = useSelector((state) => get(state, `filter.users.courses`, UserFilter()));
  // const authrealm = useSelector((state) => get(state, 'auth.realm'));
  // const realmid = useSelector((state) => get(state, 'auth.realm.id'));
  const dispatch = useDispatch();
  // const { status, permission } = filter; // realm_type,

  const { isMobile } = useScreen();

  const classes = useStyles({ isMobile });

  useEffect(() => {
    setShowFilters(!isMobile);
  }, [isMobile]);

  // useEffect(() => {
  //   const foundInVendors = get(vendors, 'data', []).find(v => `${v.clientId}` === `${get(authrealm, 'topRealm.id')}`);
  //   if (foundInVendors && get(filter, 'client_id') !== foundInVendors.id) {
  //     changeFilter(set({ ...filter }, 'client_id', foundInVendors.id));
  //   }
  // }, [realmid, authrealm]);

  const changeFilter = (filt) => {
    dispatch(setFilter('users', 'courses', filt));
  };

  // const handleStatusChange = e => {
  //   changeFilter(set({ ...filter }, `status`, e.target.value));
  // }

  const handleDisplayChange = (e) => {
    const val = e.target.value;
    changeFilter(set({ ...filter }, 'report_type', val));
  };

  function toggleFilters() {
    setShowFilters(!showFilters);
  }

  return (
    <Box displayPrint="none">
      <div className={classes.grid}>
        {isMobile && (
          <Button aria-label="filters" size="small" onClick={toggleFilters}>
            <FilterIcon fontSize="inherit" className={classes.icon} /> {showFilters ? 'Hide Filters' : 'Filters'}
          </Button>
        )}

        <DiagContainer useDialog={isMobile} onClose={toggleFilters} open={showFilters}>
          <Typography variant="overline">Filters</Typography>

          <form autoComplete="off" margin="normal" className={classes.form}>
            <Grid container>
              {/* <Grid item md={12} className={classes.formGrid}>
                <div className={classes.flexFilters}>
                  <FormControl component="fieldset" className={classes.formItem}>
                    <FormLabel component="legend">Status</FormLabel>
                    <RadioGroup
                      size="small" 
                      value={status} 
                      onChange={e => handleStatusChange(e)}
                    >
                      {UserStatus.map((ed, i) => 
                        <FormControlLabel
                          key={i}
                          control={<Radio />}
                          label={ed.title}
                          value={ed.value}
                        />)}
                    </RadioGroup>
                  </FormControl>
                </div>
              </Grid> */}

              <Grid item md={12} className={classes.formGrid}>
                <div className={classes.flexFilters}>
                  <FormControl variant="standard" className={classes.formItem}>
                    <InputLabel htmlFor="Standard-scorecard-simple">Display</InputLabel>
                    <Select value={get(filter, 'report_type')} onChange={handleDisplayChange} input={<Input name="scorecard" id="Standard-scorecard-simple" />}>
                      {CourseDisplay.map((course) => {
                        return (
                          <MenuItem key={course.value} value={course.value}>
                            {course.title}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
              </Grid>
            </Grid>
          </form>
        </DiagContainer>
      </div>
    </Box>
  );
}
